/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanAssetResponseDto } from './PlanAssetResponseDto';
import {
    PlanAssetResponseDtoFromJSON,
    PlanAssetResponseDtoFromJSONTyped,
    PlanAssetResponseDtoToJSON,
    PlanAssetResponseDtoToJSONTyped,
} from './PlanAssetResponseDto';

/**
 * 
 * @export
 * @interface AssignPlanAssetsResponseDto
 */
export interface AssignPlanAssetsResponseDto {
    /**
     * 
     * @type {Array<PlanAssetResponseDto>}
     * @memberof AssignPlanAssetsResponseDto
     */
    data: Array<PlanAssetResponseDto>;
}

/**
 * Check if a given object implements the AssignPlanAssetsResponseDto interface.
 */
export function instanceOfAssignPlanAssetsResponseDto(value: object): value is AssignPlanAssetsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function AssignPlanAssetsResponseDtoFromJSON(json: any): AssignPlanAssetsResponseDto {
    return AssignPlanAssetsResponseDtoFromJSONTyped(json, false);
}

export function AssignPlanAssetsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignPlanAssetsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PlanAssetResponseDtoFromJSON)),
    };
}

export function AssignPlanAssetsResponseDtoToJSON(json: any): AssignPlanAssetsResponseDto {
    return AssignPlanAssetsResponseDtoToJSONTyped(json, false);
}

export function AssignPlanAssetsResponseDtoToJSONTyped(value?: AssignPlanAssetsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PlanAssetResponseDtoToJSON)),
    };
}

